// extracted by mini-css-extract-plugin
export default {"melodyVideo":"FK-z","isFullWidth":"GK-z","landingPageVideo":"HK-z","play":"IK-z","iframeVideo":"JK-z","playHidden":"KK-z","fullwidth":"LK-z"};